<template>
  <div>
    <!-- 主 Modal -->
    <div v-if="!showSettingsPanel" class="modal-overlay">
      <div class="modal-container" :class="{ 'wide': isAigame }">
        <!-- 標題列 -->
        <div class="modal-header">
          <!-- QR Code 返回按鈕 -->
          <button v-if="showQRCode" class="back-btn" @click="closeQRCodeModal">
            <svg-icon icon-class="arrow-pre" />
          </button>
          <h3 class="modal-title">{{ showQRCode ? t('gameActManager.qrcodeTitle') : t('gameActManager.updateActivity') }}</h3>
          <button v-if="!showQRCode" class="close-btn" @click="handleClose">×</button>
        </div>

        <!-- 內容區 -->
        <div class="modal-body">
          <!-- QR Code 視圖 -->
          <div v-if="showQRCode" class="qrcode-view">
            <canvas ref="qrcodeCanvas" class="qrcode-canvas"></canvas>
            <div class="url-wrap url-wrap-centered">
              <span class="url-title">URL：</span>{{ shortURLHost }}<span class="short-url">{{ props.activity.shortUrlCode }}</span>
            </div>
          </div>

          <!-- 原本的表單內容 -->
          <div v-else class="update-body-layout" :class="{ 'has-thumbnail': isAigame }">
            <!-- 左側縮圖（aigame 才顯示） -->
            <div v-if="isAigame" class="update-thumbnail-col">
              <div
                class="update-thumbnail-wrap"
                @click="triggerFileInput"
              >
                <img :src="currentThumbnailSrc" alt="縮圖" class="update-thumbnail-img">
                <div class="thumbnail-overlay">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="28" height="28">
                    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                  </svg>
                </div>
              </div>
              <div v-if="uploadError" class="thumbnail-error">{{ uploadError }}</div>
              <input
                ref="thumbnailFileInput"
                type="file"
                accept="image/jpeg,image/png,image/webp"
                class="thumbnail-file-input"
                @change="handleThumbnailChange"
              />
            </div>

            <!-- 右側表單（原有內容不動） -->
            <div class="update-form-col">
            <!-- 活動名稱 -->
            <div class="form-group">
            <div class="input-with-counter">
              <input
                v-model="formData.activityName"
                type="text"
                class="form-input"
                :placeholder="t('gameActManager.activityNamePlaceholder')"
                maxlength="20"
              />
              <span class="char-counter">{{ formData.activityName.length }}/20</span>
            </div>
            <div v-if="errors.activityName" class="error-text">{{ errors.activityName }}</div>
          </div>

          <!-- 遊戲詳細內容設定入口與馬上試玩 -->
          <div class="form-group">
            <div class="setting-row">
              <div
                class="setting-link setting-link-half"
                :class="{ 'disabled': isSettingsLocked }"
                @click="openGameSettings"
              >
                <span>{{ t('gameActManager.gameSettingsEntry') }}</span>
                <svg-icon icon-class="arrow-next" class="arrow-icon" />
              </div>
              <button
                class="btn btn-try-now"
                @click="handleTryNow"
              >
                {{ t('gameActManager.tryNow') }}
              </button>
            </div>
            <div v-if="isSettingsLocked" class="warning-text">
              {{ t('gameActManager.settingsLockedWarning') }}
            </div>
          </div>

          <!-- 發布短網址按鈕（僅在未發布時顯示） -->
          <div v-if="!hasPublishedUrl" class="form-group">
            <button
              class="btn btn-publish-full"
              @click="handlePublish"
            >
              {{ t('gameActManager.publish') }}
            </button>
          </div>

          <!-- 短網址顯示區（僅在已發布後顯示） -->
          <div v-if="hasPublishedUrl" class="form-group">
            <div class="url-wrap url-wrap-centered">
              <span class="url-title">URL：</span>{{ shortURLHost }}<span class="short-url">{{ props.activity.shortUrlCode }}</span>
              <span class="copy-btn" @click="copyShareUrl">
                <svg-icon icon-class="copy" />
              </span>
              <!-- QR Code 按鈕 -->
              <span class="qrcode-btn" @click="showQRCodeModal">
                <svg-icon icon-class="qrcode-new" />
              </span>
              <!-- 發送連結按鈕（僅在 webview 或 iframe 環境顯示） -->
              <span v-if="isWebviewOrIframe" class="send-link-btn" @click="handleSendLink" :class="{ 'is-querying': isQueryingClass }">
                <svg-icon v-if="!isQueryingClass" icon-class="upload" />
                <span v-else class="query-spinner" />
              </span>
            </div>
          </div>

          <!-- 開放進入活動（只在已發布短網址後顯示） -->
          <div v-if="hasPublishedUrl" class="form-group enable-entry-row">
            <label class="form-label-large">{{ t('gameActManager.enableEntry') }}</label>
            <div class="toggle-switch">
              <input
                type="checkbox"
                id="enableEntry"
                v-model="formData.enableEntry"
                class="toggle-input"
              />
              <label for="enableEntry" class="toggle-label"></label>
            </div>
          </div>

          <!-- 檢視成績表現（只在已發布短網址後顯示） -->
          <div v-if="hasPublishedUrl" class="form-group">
            <div
              class="setting-link view-scores-link"
              @click="openScoresPanel"
            >
              <span>{{ t('gameActManager.viewScores') }}</span>
              <svg-icon icon-class="arrow-next" class="arrow-icon" />
            </div>
          </div>
            </div>
          </div>
        </div>

        <!-- 底部按鈕（QR Code 視圖時隱藏） -->
        <div v-if="!showQRCode" class="modal-footer">
          <button class="btn btn-cancel" @click="handleClose">{{ t('gameActManager.cancel') }}</button>
          <button class="btn btn-confirm" @click="handleSubmit">{{ t('gameActManager.confirm') }}</button>
        </div>

        <!-- 步驟四引導 -->
        <GuideStep4 ref="guideStep4Ref" :activity-count="totalActivityCount" />
      </div>
    </div>

    <!-- 遊戲設定面板 -->
    <GameSettingsPanel
      v-if="showSettingsPanel"
      :settings="gameSettings"
      :activity-name="formData.activityName"
      :question-type="questionType"
      :question-type-label="questionTypeLabel"
      :hide-source-code="!!(props.activity.isCopied && !props.activity.isSourceCodeOpen)"
      @back="closeGameSettings"
      @update="updateGameSettings"
    />

    <!-- 成績查看面板 -->
    <ActivityScoresPanel
      v-if="showScoresPanel"
      :activity-id="props.activity.id"
      :activity-name="formData.activityName"
      :roster-source="formData.classRosterSource"
      @back="closeScoresPanel"
    />

    <!-- 遊戲預覽 iframe 彈窗 (WebView 環境) -->
    <div v-if="showGamePreviewModal" class="modal-overlay game-preview-overlay">
      <div class="game-preview-modal">
        <iframe
          :src="gamePreviewUrl"
          class="game-preview-iframe"
          frameborder="0"
          allowfullscreen
          sandbox="allow-scripts allow-same-origin"
          referrerpolicy="strict-origin-when-cross-origin"
        ></iframe>
        <button class="preview-close-btn" @click="closeGamePreviewModal">
          <svg-icon icon-class="close" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { reactive, computed, inject, ref, onMounted, onUnmounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMainStore } from '../../stores/mainStore';
import SvgIcon from '../../components/SvgIcon.vue';
import GameSettingsPanel from './GameSettingsPanel.vue';
import ActivityScoresPanel from './ActivityScoresPanel.vue';
import GuideStep4 from './GuideStep4.vue';
import gameActivityAPI from '@/api/gameActivityAPI';
import mindmapAPI from '@/api/mindmapAPI';
import confProfile from '@/api/profile';
import api from '@/api';
import QRCode from 'qrcode';
import { useGameThumbnailUpload } from '@/composable/useGameThumbnailUpload';

// 訊息橋接器（用於 WebView 通訊）
const MessageBridge = {
  ENV: { WEBVIEW: 'webview', WEB: 'web' },
  currentEnv: 'web',
  init() {
    this.currentEnv = window?.chrome?.webview ? this.ENV.WEBVIEW : this.ENV.WEB;
    return this;
  },
  postMessage(data) {
    if (this.currentEnv === this.ENV.WEBVIEW) {
      window?.chrome?.webview.postMessage(data);
    } else {
      window.postMessage(data, '*');
      try {
        if (window.parent && window.parent !== window) {
          window.parent.postMessage(data, '*');
        }
      } catch (e) { /* 跨域略過 */ }
    }
  },
  postMessageToParent(data, origin = '*') {
    try {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(data, origin);
      }
    } catch (e) {
      console.warn('[MessageBridge] postMessageToParent 失敗:', e);
    }
  },
  addEventListener(callback) {
    if (this.currentEnv === this.ENV.WEBVIEW) {
      window?.chrome?.webview.addEventListener('message', callback);
    } else {
      window.addEventListener('message', callback);
    }
  },
  removeEventListener(callback) {
    if (this.currentEnv === this.ENV.WEBVIEW) {
      window?.chrome?.webview.removeEventListener('message', callback);
    } else {
      window.removeEventListener('message', callback);
    }
  }
};

// 初始化訊息橋接器
const messageBridge = MessageBridge.init();

const { t, locale } = useI18n();
const store = useMainStore();

// Props
const props = defineProps({
  activity: {
    type: Object,
    required: true
  },
  creator: {
    type: Object,
    required: false,
    default: () => ({ id: '', name: '' })
  },
  activityCount: {
    type: Number,
    default: 0
  }
});

// Emits
const emit = defineEmits(['close', 'updated']);

// Inject
const $Message = inject('$Message');

// 遊戲設定面板顯示狀態
const showSettingsPanel = ref(false);

// 成績查看面板顯示狀態
const showScoresPanel = ref(false);

// 步驟四引導 ref
const guideStep4Ref = ref(null);

// 總活動數量（從父組件傳入，用於引導判斷）
const totalActivityCount = ref(props.activityCount || 1);

// 從現有活動解析遊戲設定
const parseGameSettings = () => {
  try {
    const settings = props.activity.gameContentSettings
      ? JSON.parse(props.activity.gameContentSettings)
      : {};

    // 將名單相關欄位一併帶入 gameParameters，方便子組件從 props.settings 取得
    if (props.activity.classRosterSource) {
      settings.classRosterSource = props.activity.classRosterSource;
    }
    if (props.activity.classRoster) {
      settings.classRoster = props.activity.classRoster;
    }

    return {
      playerCount: props.activity.playerCount ?? 1,
      currentGame: props.activity.currentGame ?? 'mole',
      allowTemplateChange: props.activity.allowTemplateChange ?? false,
      gameParameters: settings
    };
  } catch (error) {
    console.error('解析遊戲設定失敗:', error);
    return {
      playerCount: 1,
      currentGame: 'mole',
      allowTemplateChange: false,
      gameParameters: {}
    };
  }
};

// 遊戲設定資料
const gameSettings = reactive(parseGameSettings());

// 縮圖上傳
const isAigame = computed(() => (gameSettings.currentGame || props.activity.currentGame) === 'aigame');
const thumbnailFileInput = ref(null);
const currentThumbnailSrc = ref(
    props.activity.thumbnailUrl || require('@/assets/HTwbActAssets/home/cover-aigame.webp')
);
const { isUploading: isThumbnailUploading, uploadError, uploadThumbnail } = useGameThumbnailUpload();

const triggerFileInput = () => {
    thumbnailFileInput.value?.click();
};

const handleThumbnailChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    // 本機預覽
    const previewUrl = URL.createObjectURL(file);
    currentThumbnailSrc.value = previewUrl;
    // 上傳並更新 DB
    const thumbnailUrl = await uploadThumbnail(file, props.activity.id);
    if (thumbnailUrl) {
        await gameActivityAPI.updateGameActivity({ id: props.activity.id, thumbnailUrl });
        // 用真實 URL 取代本機預覽
        URL.revokeObjectURL(previewUrl);
        currentThumbnailSrc.value = thumbnailUrl;
    } else {
        // 上傳失敗，還原預覽
        URL.revokeObjectURL(previewUrl);
        currentThumbnailSrc.value = props.activity.thumbnailUrl || require('@/assets/HTwbActAssets/home/cover-aigame.webp');
    }
};

// 表單資料
const formData = reactive({
  activityName: props.activity.activityName || '',
  questionType: props.activity.questionType || 'recognition',
  classRosterSource: props.activity.classRosterSource || 'general',
  enableEntry: props.activity.enableEntry || false,
  currentGame: gameSettings.currentGame,
  playerCount: gameSettings.playerCount
});

// 錯誤訊息
const errors = reactive({
  activityName: ''
});

// 題目類型
const questionType = computed(() => formData.questionType);

// 題目類型標籤
const questionTypeLabel = computed(() => {
  const labels = {
    recognition: t('gameActManager.recognition'),
    trueFalse: t('gameActManager.trueFalse'),
    multiChoice: t('gameActManager.multiChoice')
  };
  return labels[formData.questionType] || '';
});

// 計算是否已發布短網址
const hasPublishedUrl = computed(() => {
  return !!(props.activity.shortUrlCode && props.activity.shortUrlCode.trim() !== '');
});

// 計算是否鎖定遊戲設定
// 條件：已發布短網址 且 開放進入活動
const isSettingsLocked = computed(() => {
  return hasPublishedUrl.value && formData.enableEntry;
});

// 判斷是否在 WebView 或 iframe 環境
const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const isWebviewOrIframe = computed(() => {
  return window?.chrome?.webview !== undefined || isInIframe();
});

// 取得短網址主機
const serverLocation = api.main.getServerLocation();
const shortURLHost = confProfile.shortUrlHost[serverLocation];

// 複製短網址
const copyShareUrl = () => {
  if (!props.activity.shortUrlCode) return;

  const fullUrl = shortURLHost + props.activity.shortUrlCode;
  navigator.clipboard.writeText(fullUrl).then(() => {
    $Message.success(t('gameActManager.shortUrlCopied'));
  }).catch(() => {
    $Message.error(t('gameActManager.copyFailed'));
  });
};

// 馬上試玩功能（開啟遊戲預覽）
const handleTryNow = () => {
  // 根據遊戲類型決定路由路徑
  const getPreviewPath = () => {
    const currentGame = gameSettings.currentGame || props.activity.currentGame || 'mole';
    if (currentGame === 'mole') return '/ht-molegame-play';
    if (currentGame === 'star') return '/ht-pvpgame-play';
    if (currentGame === 'tf') return '/ht-pvp-tfgame-play';
    if (currentGame === 'snake') return '/ht-snakegame-play';
    if (currentGame === 'maze') return '/ht-mazegame-play';
    if (currentGame === 'aigame') return '/ht-aigame-play';
    return '/ht-molegame-play';
  };

  // 收集當前設定參數
  const previewData = {
    playerCount: gameSettings.playerCount || props.activity.playerCount || 1,
    currentGame: gameSettings.currentGame || props.activity.currentGame || 'mole',
    allowTemplateChange: gameSettings.allowTemplateChange || props.activity.allowTemplateChange || false,
    questionType: formData.questionType,
    gameParameters: gameSettings.gameParameters || {}
  };

  // 將預覽參數存入 localStorage
  try {
    localStorage.setItem('game_preview_data', JSON.stringify(previewData));
    localStorage.setItem('game_preview_timestamp', Date.now().toString());
    console.log('[試玩] localStorage 寫入成功');
  } catch (error) {
    console.error('[試玩] localStorage 寫入錯誤:', error);
    return;
  }

  const previewPath = getPreviewPath();

  // WebView 或 iframe 環境：使用 iframe 彈窗
  // 一般瀏覽器環境：開啟新分頁
  setTimeout(() => {
    if (isWebviewOrIframe.value) {
      console.log('[試玩] WebView/iframe 環境，使用 iframe 彈窗:', previewPath);
      showGamePreviewModal.value = true;
      gamePreviewUrl.value = previewPath;
    } else {
      console.log('[試玩] 瀏覽器環境，開啟新分頁:', previewPath);
      window.open(previewPath, '_blank');
    }
  }, 100);
};

// 遊戲預覽 iframe 彈窗狀態
const showGamePreviewModal = ref(false);
const gamePreviewUrl = ref('');

// 關閉遊戲預覽 Modal
const closeGamePreviewModal = () => {
  showGamePreviewModal.value = false;
  gamePreviewUrl.value = '';
};

// QR Code 相關狀態
const showQRCode = ref(false);
const qrcodeCanvas = ref(null);

// 顯示 QR Code Modal
const showQRCodeModal = async () => {
  showQRCode.value = true;
  await nextTick();
  generateQRCode();
};

// 關閉 QR Code Modal
const closeQRCodeModal = () => {
  showQRCode.value = false;
};

// 生成 QR Code
const generateQRCode = async () => {
  if (!qrcodeCanvas.value || !props.activity.shortUrlCode) return;

  const fullUrl = shortURLHost + props.activity.shortUrlCode;

  try {
    await QRCode.toCanvas(qrcodeCanvas.value, fullUrl, {
      width: 280,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    });
  } catch (error) {
    console.error('生成 QR Code 失敗:', error);
    $Message.error(t('gameActManager.qrcodeGenerateFailed'));
  }
};

// 發送連結到 HiTeach (WebView) 或父視窗 (iframe)
const handleSendLink = async () => {
  if (!props.activity.shortUrlCode) {
    $Message.error(t('gameActManager.sendLinkFailed'));
    return;
  }

  // 先詢問 HT 目前是否開始課堂
  const inClass = await queryHTStartClass();
  if (!inClass) {
    $Message.warning(t('gameActManager.noClassCannotPush'));
    return;
  }

  const shortUrl = shortURLHost + props.activity.shortUrlCode;
  const currentGame = gameSettings.currentGame || props.activity.currentGame || 'mole';

  // 根據遊戲類型決定 gameType
  const getGameType = () => {
    if (currentGame === 'mole') return 'molegame';
    if (currentGame === 'star') return 'pvpgame';
    if (currentGame === 'tf') return 'pvptfgame';
    if (currentGame === 'snake') return 'snakegame';
    if (currentGame === 'maze') return 'mazegame';
    if (currentGame === 'aigame') return 'aigame';
    return 'molegame';
  };

  // 根據遊戲類型決定遊戲路由
  const getGameRoute = () => {
    if (currentGame === 'mole') return '/ht-molegame-play';
    if (currentGame === 'star') return '/ht-pvpgame-play';
    if (currentGame === 'tf') return '/ht-pvp-tfgame-play';
    if (currentGame === 'snake') return '/ht-snakegame-play';
    if (currentGame === 'maze') return '/ht-mazegame-play';
    if (currentGame === 'aigame') return '/ht-aigame-play';
    return '/ht-molegame-play';
  };

  // 構建長網址（原始 URL）
  const originalUrl = `${window.location.origin}${getGameRoute()}?actId=${props.activity.id}`;

  const messageData = {
    action: 'SendGameLink.WebIRS',
    data: {
      // url 為長網址，shortUrl 為短網址（與 useGameActivityPush 保持一致）
      url: originalUrl,
      shortUrl: shortUrl,
      activityId: props.activity.id,
      gameType: getGameType()
    }
  };

  // WebView 環境
  if (window?.chrome?.webview) {
    messageBridge.postMessage(messageData);
    $Message.success(t('gameActManager.sendLinkSuccess'));
    console.log('[發送連結] WebView 已發送，長網址:', originalUrl, '短網址:', shortUrl);
  }
  // iframe 環境
  else if (isInIframe()) {
    messageBridge.postMessageToParent(messageData, '*');
    $Message.success(t('gameActManager.sendLinkSuccess'));
    console.log('[發送連結] iframe 已發送，長網址:', originalUrl, '短網址:', shortUrl);
  }
  else {
    $Message.error(t('gameActManager.sendLinkFailed'));
  }
};

// 檢查簡碼有效性並自動重新生成的函數
const checkAndRefreshClipCodeIfNeeded = async (activityData) => {
  if (!activityData || !activityData.shortUrlCode) {
    return;
  }

  const now = Date.now();
  const ninetyDaysInMs = 90 * 24 * 60 * 60 * 1000; // 90天的毫秒數

  // 檢查是否有 shortUrlCodeUpdateTime，如果沒有或超過90天，則檢查簡碼有效性
  if (!activityData.shortUrlCodeUpdateTime || (now - activityData.shortUrlCodeUpdateTime) > ninetyDaysInMs) {
    try {
      const checkData = { clipCode: activityData.shortUrlCode };
      await mindmapAPI.getOrigDataFromClipCode(checkData);
      // 簡碼仍有效，不需重新生成
    } catch (error) {
      if (error.response?.status === 404) {
        // 簡碼已失效，重新生成
        await autoRefreshClipCode(activityData);
      } else {
        console.error("檢查簡碼時發生錯誤:", error);
      }
    }
  }
};

// 自動重新生成簡碼的函數
const autoRefreshClipCode = async (activityData) => {
  try {
    // 根據遊戲類型和人數決定路由
    const getGameRoute = () => {
      if (activityData.currentGame === 'mole') {
        return '/ht-molegame-play';
      }
      if (activityData.currentGame === 'star') {
        return '/ht-pvpgame-play';
      }
      if (activityData.currentGame === 'tf') {
        return '/ht-pvp-tfgame-play';
      }
      if (activityData.currentGame === 'snake') {
        return '/ht-snakegame-play';
      }
      return '/ht-molegame-play';
    };

    // 生成原始 URL
    const gameRoute = getGameRoute();
    const origData = `${window.location.origin}${gameRoute}?actId=${activityData.id}`;

    // 呼叫短網址生成 API
    const clipCodeResponse = await mindmapAPI.getClipCode({
      origDataList: [{ origData }],
      type: "url",
      useShortDigits: false,
      isPermanent: false,
      lang: locale.value.toLowerCase(),
      note: JSON.stringify({
        activityName: activityData.activityName,
        currentGame: activityData.currentGame,
        playerCount: activityData.playerCount
      })
    });

    const newClipCode = clipCodeResponse.clipCodePairs[0].clipCode;

    // 更新活動的簡碼
    const updateData = {
      id: activityData.id,
      activityName: activityData.activityName,
      creator: activityData.creator,
      currentGame: activityData.currentGame,
      questionType: activityData.questionType,
      gameContentSettings: activityData.gameContentSettings,
      classRosterSource: activityData.classRosterSource,
      classRoster: activityData.classRoster || JSON.stringify({ students: [] }),
      shortUrlCode: newClipCode,
      shortUrlCodeUpdateTime: Date.now(), // 記錄更新時間
      enableEntry: activityData.enableEntry,
      playerCount: activityData.playerCount,
      allowTemplateChange: activityData.allowTemplateChange
    };
    await gameActivityAPI.updateGameActivity(updateData);

    // 更新本地資料
    activityData.shortUrlCode = newClipCode;
    activityData.shortUrlCodeUpdateTime = Date.now();

    // 顯示簡碼更新提示
    $Message.warning(t('gameActManager.shortUrlAutoUpdated'));
    console.log("簡碼已自動更新:", newClipCode);

  } catch (error) {
    console.error("自動重新獲取簡碼失敗:", error);
  }
};



// 驗證表單
const validateForm = () => {
  errors.activityName = '';

  if (!formData.activityName || formData.activityName.trim() === '') {
    errors.activityName = t('gameActManager.activityNameRequired');
    return false;
  }

  if (formData.activityName.length > 20) {
    errors.activityName = t('gameActManager.activityNameTooLong');
    return false;
  }

  return true;
};

// 提交表單
const handleSubmit = async () => {
  if (!validateForm()) {
    return;
  }

  try {
    // 準備 API 請求資料
    const requestData = {
      id: props.activity.id,
      activityName: formData.activityName,
      creator: {
        id: (props.creator && props.creator.id) ? props.creator.id : (store.profile?.id || ''),
        name: (props.creator && props.creator.name) ? props.creator.name : (store.profile?.name || '')
      },
      currentGame: gameSettings.currentGame,
      questionType: formData.questionType,
      gameContentSettings: JSON.stringify(gameSettings.gameParameters),
      // 名單相關欄位改為優先使用 gameSettings 中最新的設定
      classRosterSource: (gameSettings.gameParameters && gameSettings.gameParameters.classRosterSource)
        ? gameSettings.gameParameters.classRosterSource
        : formData.classRosterSource,
      classRoster: (gameSettings.gameParameters && gameSettings.gameParameters.classRoster)
        ? gameSettings.gameParameters.classRoster
        : (props.activity.classRoster || JSON.stringify({ students: [] })),
      shortUrlCode: props.activity.shortUrlCode || '',
      enableEntry: formData.enableEntry,
      playerCount: gameSettings.playerCount,
      allowTemplateChange: gameSettings.allowTemplateChange
    };

    console.log('更新活動資料:', requestData);

    // 呼叫 API 更新活動
    const response = await gameActivityAPI.updateGameActivity(requestData);

    console.log('更新活動成功:', response);
    emit('updated', response);
  } catch (error) {
    console.error('更新活動失敗:', error);
    $Message.error(error.message || t('gameActManager.activityUpdateFailed'));
  }
};

// 發布短網址（生成短網址並更新活動）
const handlePublish = async () => {
  // 隱藏步驟四引導
  if (guideStep4Ref.value) {
    guideStep4Ref.value.hideGuide();
  }

  if (!validateForm()) {  
    return;
  }

  try {
    // 1. 根據遊戲類型和人數決定路由
    const getGameRoute = () => {
      // AI 自定義遊戲
      if (gameSettings.currentGame === 'aigame') {
        return '/ht-aigame-play';
      }
      
      // 打地鼠只有單人模式
      if (gameSettings.currentGame === 'mole') {
        return '/ht-molegame-play';
      }

      // 摘星星不管單雙人都是 pvpgame-play
      if (gameSettings.currentGame === 'star') {
        return '/ht-pvpgame-play';
      }

      // 是非題火箭升空遊戲
      if (gameSettings.currentGame === 'tf') {
        return '/ht-pvp-tfgame-play';
      }

      // 貪食蛇遊戲（支援單人和雙人模式）
      if (gameSettings.currentGame === 'snake') {
        return '/ht-snakegame-play';
      }

      // 迷宮遊戲（單選題，單人模式）
      if (gameSettings.currentGame === 'maze') {
        return '/ht-mazegame-play';
      }

      // 預設路由（不應該發生）
      return '/ht-molegame-play';
    };

    // 2. 生成原始 URL（包含 actId 參數）
    const gameRoute = getGameRoute();
    const origData = `${window.location.origin}${gameRoute}?actId=${props.activity.id}`;

    console.log('準備生成短網址:', {
      currentGame: gameSettings.currentGame,
      playerCount: gameSettings.playerCount,
      route: gameRoute,
      origData
    });

    // 3. 呼叫短網址生成 API
    const clipCodeResponse = await mindmapAPI.getClipCode({
      origDataList: [{ origData }],
      type: "url",
      useShortDigits: false,
      isPermanent: false,
      lang: locale.value.toLowerCase(),
      note: JSON.stringify({
        activityName: formData.activityName,
        currentGame: gameSettings.currentGame,
        playerCount: gameSettings.playerCount
      })
    });


    const shortUrlCode = clipCodeResponse.clipCodePairs[0].clipCode;
    console.log('短網址生成成功:', shortUrlCode);

    // 4. 更新活動（寫入 shortUrlCode 和 shortUrlCodeUpdateTime，並自動開放進入）
    const requestData = {
      id: props.activity.id,
      activityName: formData.activityName,
      creator: {
        id: (props.creator && props.creator.id) ? props.creator.id : (store.profile?.id || ''),
        name: (props.creator && props.creator.name) ? props.creator.name : (store.profile?.name || '')
      },
      currentGame: gameSettings.currentGame,
      questionType: formData.questionType,
      gameContentSettings: JSON.stringify(gameSettings.gameParameters),
      // 名單相關欄位改為優先使用 gameSettings 中最新的設定
      classRosterSource: (gameSettings.gameParameters && gameSettings.gameParameters.classRosterSource)
        ? gameSettings.gameParameters.classRosterSource
        : formData.classRosterSource,
      classRoster: (gameSettings.gameParameters && gameSettings.gameParameters.classRoster)
        ? gameSettings.gameParameters.classRoster
        : (props.activity.classRoster || JSON.stringify({ students: [] })),
      shortUrlCode: shortUrlCode,  // 新增短網址碼
      shortUrlCodeUpdateTime: Date.now(),  // 記錄更新時間
      enableEntry: true,  // 發布短網址時自動開放進入
      playerCount: gameSettings.playerCount,
      allowTemplateChange: gameSettings.allowTemplateChange
    };

    console.log('更新活動資料:', requestData);
    const response = await gameActivityAPI.updateGameActivity(requestData);

    if (response) {
      $Message.success(t('gameActManager.shortUrlPublished'));
      // 更新本地資料，讓畫面即時顯示
      props.activity.shortUrlCode = shortUrlCode;
      props.activity.enableEntry = true;
      formData.enableEntry = true;
      // 不關閉視窗，讓使用者可以繼續編輯其他設定
    }
  } catch (error) {
    console.error('發布短網址失敗:', error);
    $Message.error(error.message || t('gameActManager.shortUrlPublishFailed'));
  }
};

// 關閉 Modal
const handleClose = () => {
  emit('close');
};

// 開啟遊戲詳細設定
const openGameSettings = () => {
  // 如果已鎖定（已發布短網址且開放進入活動），則不允許修改設定
  if (isSettingsLocked.value) {
    $Message.warning(t('gameActManager.settingsLockedWarning'));
    return;
  }
  // 進入遊戲設定時，將活動名稱同步到主題欄位
  if (!gameSettings.gameParameters) {
    gameSettings.gameParameters = {};
  }
  gameSettings.gameParameters.topic = formData.activityName;
  showSettingsPanel.value = true;
};

// 關閉遊戲設定面板
const closeGameSettings = () => {
  // 返回時，如果主題有變更，同步回活動名稱
  if (gameSettings.gameParameters && gameSettings.gameParameters.topic) {
    formData.activityName = gameSettings.gameParameters.topic;
  }
  showSettingsPanel.value = false;
};

// 更新遊戲設定
const updateGameSettings = (newSettings) => {
  Object.assign(gameSettings, newSettings);
  formData.currentGame = gameSettings.currentGame;
  formData.playerCount = gameSettings.playerCount;
  // 同步名單來源到表單資料，確保後續送出 API 使用最新設定
  if (gameSettings.gameParameters && gameSettings.gameParameters.classRosterSource) {
    formData.classRosterSource = gameSettings.gameParameters.classRosterSource;
  }
};

// 開啟成績查看面板
const openScoresPanel = () => {
  showScoresPanel.value = true;
};

// 關閉成績查看面板
const closeScoresPanel = () => {
  showScoresPanel.value = false;
};

// 組件掛載時檢查簡碼並顯示提示
// HiTeach 上課狀態（由 Send.HTStartClass 更新）
const htStartClass = ref(true);
let htStartClassPending = null;
const isQueryingClass = ref(false);

// 詢問 HT 目前是否開始課堂，等待 Send.HTStartClass 回應
const queryHTStartClass = () => {
  return new Promise((resolve) => {
    isQueryingClass.value = true;
    let settled = false;
    const done = (result) => {
      if (settled) return;
      settled = true;
      isQueryingClass.value = false;
      resolve(result);
    };
    htStartClassPending = done;
    messageBridge.postMessage({ action: 'Get.HTStartClass' });
    setTimeout(() => done(true), 2000);
  });
};

// 訊息監聽器（處理 Send.HTStartClass）
const modalMessageHandler = (event) => {
  const msg = event.data;
  if (msg?.action === 'Send.HTStartClass') {
    const inClass = msg.data?.HTStartClass ?? true;
    htStartClass.value = inClass;
    if (htStartClassPending) {
      htStartClassPending(inClass);
      htStartClassPending = null;
    }
  }
};

onMounted(async () => {
  // 檢查並自動更新簡碼（如果超過90天且無效）
  await checkAndRefreshClipCodeIfNeeded(props.activity);
  messageBridge.addEventListener(modalMessageHandler);
});

onUnmounted(() => {
  messageBridge.removeEventListener(modalMessageHandler);
});
</script>

<style lang="less" scoped>
@import "../../assets/color.less";
@import "../../assets/gameActManager.less";

// Modal 遮罩層
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  z-index: 9999;
}

// Modal 容器
.modal-container {
  position: relative;
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &.wide {
    max-width: 700px;
  }
}

// aigame 左右分欄佈局
.update-body-layout {
  &.has-thumbnail {
    display: grid;
    grid-template-columns: 200px 1fr;
    gap: 20px;
    align-items: start;

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }
}

.update-thumbnail-col {
  display: flex;
  flex-direction: column;
}

.update-thumbnail-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);

  .update-thumbnail-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .thumbnail-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s;
  }

  &:hover .thumbnail-overlay {
    opacity: 1;
  }
}

.thumbnail-file-input {
  display: none;
}

.thumbnail-error {
  margin-top: 6px;
  font-size: 12px;
  color: #ff4d4f;
  text-align: center;
}

.update-form-col {
  min-width: 0;
}

// 標題列
.modal-header {
  padding: 16px 24px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  line-height: 1.2;
  flex: 1;
}

.modal-header:has(.back-btn) .modal-title {
  text-align: center;
  padding: 0 40px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
  position: absolute;
  right: 24px;

  &:hover {
    background-color: #f5f5f5;
    color: #666;
  }
}

// 內容區
.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  // QR Code 視圖時移除 padding
  &:has(.qrcode-view) {
    padding: 0;
  }
}

.form-group {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
  line-height: 1.6;
}

.input-with-counter {
  position: relative;
  width: 100%;
}

.form-input {
  width: 100%;
  padding: 5px 12px;
  font-size: 20px;
  line-height: 1.6;
  border: 2px solid #d9d9d9;
  border-radius: 6px;
  transition: border-color 0.2s;
  color: black;
  font-weight: bolder;

  &:focus {
    outline: none;
    border-color: @game-primary-color;
  }

  &::placeholder {
    color: #bfbfbf;
  }
}

.char-counter {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #999;
  pointer-events: none;
  line-height: 1.6;
}

.error-text {
  margin-top: 6px;
  font-size: 13px;
  color: #ff4d4f;
  line-height: 1.6;
}

.warning-text {
  margin-top: 6px;
  font-size: 13px;
  color: @game-primary-color;
  line-height: 1.6;
}

// 遊戲詳細內容設定入口
.setting-link {
  padding: 12px 16px;
  font-size: 16px;
  line-height: 1.6;
  color: @game-primary-color;
  background-color: #f9f9fb;
  border: 2px solid @game-primary-color;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 700;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  .arrow-icon {
    font-size: 18px;

    :deep(svg) {
      fill: @game-primary-color;
      stroke: @game-primary-color;
    }
  }

  &:hover:not(.disabled) {
    background-color: @game-active-color;
    border-color: @game-hover-color;
    color: @game-hover-color;

    .arrow-icon :deep(svg) {
      fill: @game-hover-color;
      stroke: @game-hover-color;
    }
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    color: #999;

    .arrow-icon :deep(svg) {
      fill: #999;
      stroke: #999;
    }
  }
}

// 設定入口與馬上試玩橫向排列
.setting-row {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

.setting-link-half {
  flex: 1;
}

// 馬上試玩按鈕
.btn-try-now {
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 6px;
  border: 2px solid @game-primary-color;
  cursor: pointer;
  transition: all 0.2s;
  line-height: 1.6;
  background-color: @game-primary-color;
  color: white;
  white-space: nowrap;

  &:hover {
    background-color: @game-hover-color;
    border-color: @game-hover-color;
  }

  &:active {
    transform: translateY(1px);
  }
}

// Toggle Switch
.toggle-switch {
  display: inline-flex;
  align-items: center;
}

.toggle-input {
  display: none;
}

.toggle-label {
  position: relative;
  width: 44px;
  height: 24px;
  background-color: #d9d9d9;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.3s;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s;
  }
}

.toggle-input:checked + .toggle-label {
  background-color: @game-primary-color;
}

.toggle-input:checked + .toggle-label::after {
  transform: translateX(20px);
}

// 開放進入活動橫向排列
.enable-entry-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form-label-large {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 0;
  line-height: 1.6;
}

// 底部按鈕
.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e8e8e8;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

.btn {
  padding: 10px 24px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  line-height: 1.6;

  &:active {
    transform: translateY(1px);
  }
}

.btn-cancel {
  background-color: #f5f5f5;
  color: #666;

  &:hover {
    background-color: #e8e8e8;
  }
}

.btn-publish-full {
  width: 100%;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  line-height: 1.6;
  background-color: @game-primary-color;
  color: white;

  &:hover {
    background-color: @game-hover-color;
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    background-color: #d9d9d9;
    color: #999;
    cursor: not-allowed;

    &:hover {
      background-color: #d9d9d9;
    }
  }
}

.btn-confirm {
  background-color: @game-primary-color;
  color: white;

  &:hover {
    background-color: @game-hover-color;
  }
}

// 短網址顯示區（參考 HTwbCardHome 樣式）
.url-wrap {
  background-color: #fff9c4; // 黃色背景
  padding: 10px;
  color: @game-primary-color;
  margin: 20px 0px 10px 0px;
  font-weight: bold;
  border-radius: 5px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.url-wrap-centered {
  justify-content: center;
}

.url-title {
  color: #333 !important;
  word-break: break-word;
  white-space: normal;
}

.short-url {
  color: black !important;
  word-break: break-word;
  font-size: 28px;
  white-space: nowrap;
  background-color: #fff;
  padding: 5px;
  border-radius: 3px;
  font-weight: bold;
}

.copy-btn {
  color: #333;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.7;
  }
}

// 發送連結按鈕
.send-link-btn {
  color: #333;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 4px;

  &.is-querying {
    cursor: not-allowed;
    pointer-events: none;
  }

  &:hover {
    color: @game-primary-color;

    :deep(svg) {
      fill: @game-primary-color;
    }
  }

  :deep(svg) {
    fill: #333;
  }
}

.query-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-top-color: @game-primary-color;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

// ========== 遊戲預覽 iframe 彈窗樣式 (與 GameSettingsPanel 一致) ==========

.game-preview-overlay {
  z-index: 20000;
  background-color: rgba(0, 0, 0, 0.7);
}

.game-preview-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 95vw;
  height: 95vh;
  max-width: 1600px;
  max-height: none;
  background-color: transparent;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: modalSlideIn 0.3s ease-out;

  @media (max-width: 768px) {
    width: 98vw;
    height: 98vh;
    border-radius: 8px;
  }

  & > * {
    position: relative;
  }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translate(-50%, -48%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

.game-preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background-color: white;
  border-radius: 12px;

  @media (max-width: 768px) {
    border-radius: 8px;
  }
}

// 遊戲預覽關閉按鈕（與 GameSettingsPanel 一致）
.preview-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.3);
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 10;
  backdrop-filter: blur(4px);

  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
    transform: scale(1.05);
  }

  :deep(svg) {
    width: 18px;
    height: 18px;
    fill: white;
    stroke: white;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.5));
  }

  @media (max-width: 768px) {
    width: 28px;
    height: 28px;

    :deep(svg) {
      width: 16px;
      height: 16px;
    }
  }
}

// ========== QR Code 相關樣式 ==========

// QR Code 按鈕（與 copy-btn 樣式一致）
.qrcode-btn {
  color: #333;
  font-size: 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 0px;

  &:hover {
    opacity: 0.7;
  }
}

// 返回按鈕（與成績檢視一致）
.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: @game-primary-color;
  font-size: 24px;
  transition: opacity 0.2s;
  position: absolute;
  left: 24px;

  &:hover {
    opacity: 0.7;
  }

  :deep(svg) {
    width: 24px;
    height: 24px;
    fill: @game-primary-color;
    stroke: @game-primary-color;
  }
}

// QR Code 視圖
.qrcode-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px 40px;
  min-height: 300px;

  .url-wrap {
    margin: 0;
    max-width: 400px;
  }
}

// QR Code Canvas
.qrcode-canvas {
  border: 4px solid @game-primary-color;
  border-radius: 8px;
  margin-bottom: 30px;
  background-color: white;
  display: block;
  max-width: 100%;
  height: auto;
}
</style>
